import { render } from "./ButtonGroup.vue?vue&type=template&id=ee0d5436&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=ee0d5436&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ee0d5436"

export default script